<div class="wrapper-reponsive">
    <div class="tlt-green-row mt-3">
        {{'STR_INSPECTION_RESULT_CONFIRM'| translate}}
    </div>
    <div class="content-box mt-2 mb-4">
        <ng-container *ngIf="objData">
            <div class="tlt-border mb-3">
                <span>{{getDayName(objData.ConsulDay)}} </span><span>{{objData.HTOrgName}}</span>
            </div>
            <div class="box-common bg-common-red mb-2">
                <div class="tlt-dot dot-red m-0">
                    <span>{{'STR_FINAL_JUDGEMENT'| translate}}</span>
                    <div class="text-center">
                        <div *ngIf="objData?.ResultShortName" class="text-view-flex">
                            <div class="left">
                                <span
                                    [ngClass]="{'text-red' : objData?.ResultShortName === 'D2' || objData?.ResultShortName === 'D1' }">{{objData?.ResultShortName}}</span>
                            </div>
                            <div class="right">　
                                <span>{{objData.CurrentResult}}</span>
                            </div>
                        </div>
                    </div>
                    <div style="font-weight: lighter;">{{objData.ResultComment}}</div>
                </div>
                <div class="box-desc">
                    <ul class="lst-item-border p-0">
                        <!-- check is the final diagnosis, exist pdf file and granted access -->
                        <li *ngIf="objData.JudgeDiv === '3' && objData.ExistPDFFile">
                            <span>{{'STR_RESULT_PDF_DOWNLOAD_BUTTON_GUIDE'|translate}}</span>
                            <div class="lst-button mt-3 text-center">
                                <button (click)="downLoad()"
                                    class="btn btn-bg-red btn-downlaod mb-2">{{'STR_RESULT_PDF_DOWNLOAD_BUTTON'|translate}}</button>
                            </div>
                        </li>
                        <li *ngIf="objData?.LastConsulDay">
                            <div class="row">
                                <div class="col-4 pr-0">
                                    <p class="tlt">{{'STR_LASTTIME'| translate}}</p>
                                </div>
                                <div class="col-8">
                                    <div class="desc">
                                        <span>{{getDayName(objData?.LastConsulDay)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="desc">
                                <div *ngIf="objData?.LastResultShortName">
                                    <div class="text-view-radius ml-2 mr-2">
                                        <span
                                            [ngClass]="{'text-red' : objData?.LastResultShortName === 'D2' || objData?.LastResultShortName === 'D1' }">{{objData?.LastResultShortName}}
                                        </span>
                                    </div>
                                    <span>　{{objData?.LastResult}}</span>
                                </div>
                            </div>
                        </li>
                        <li *ngIf="!objData?.LastConsulDay">
                            <div class="row">
                                <div class="col-4 pr-0">
                                    <p class="tlt">{{'STR_LASTTIME'| translate}}</p>
                                </div>
                                <div class="col-8">
                                    <div class="desc">
                                        <span>{{'STR_NO_HISTORY_MEDICAL'|translate}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tlt-border mb-2 mt-4">
                {{'STR_CATEGORY_RESULT_JUDGE' | translate}}
            </div>
            <div class="box-header-common">
                <button (click)="openExplanation()" class="btn-border">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" xml:space="preserve">
                        <g>
                            <path class="st0" d="M256,0C165.531,0,92.219,73.313,92.203,163.781c0,57.125,29.266,107.5,73.594,136.75   c5.203,3.438,8.75,6.375,11.094,8.875c3.453,3.813,4.688,6.266,5.891,11.156c1.141,4.844,1.531,12.281,1.516,22.844V359h143.422   v-15.594c-0.016-7.031,0.141-12.719,0.594-17.125c0.344-3.313,0.859-5.906,1.5-7.984c1.016-3.141,2.156-5.25,4.469-7.984   c2.328-2.688,6.063-5.906,11.922-9.781c44.328-29.25,73.594-79.625,73.594-136.75C419.797,73.313,346.469,0,256,0z M329,274.5   c-6.5,4.313-11.969,8.625-16.609,13.531c-7,7.313-11.578,16.375-13.578,25.625c-1.031,4.641-1.594,9.281-1.906,14.156H215   c-0.094-1.594-0.125-3.219-0.281-4.766c-0.5-4.766-1.328-9.406-2.75-13.984c-2.094-6.875-5.719-13.484-10.672-19.156   c-4.953-5.719-11-10.563-18.297-15.406c-35.938-23.766-59.594-64.406-59.594-110.719c0-36.656,14.813-69.719,38.828-93.75   C186.281,46,219.328,31.188,256,31.188S325.719,46,349.781,70.031c24,24.031,38.813,57.094,38.813,93.75   C388.594,210.094,364.953,250.734,329,274.5z" style="fill: currentColor;"></path>
                            <path class="st0" d="M311.859,383.125H200.156c-8.625,0-15.594,6.969-15.594,15.594c0,8.594,6.969,15.594,15.594,15.594h111.703   c8.609,0,15.594-7,15.594-15.594C327.453,390.094,320.469,383.125,311.859,383.125z" style="fill: currentColor;"></path>
                            <path class="st0" d="M311.859,434.516H200.156c-8.625,0-15.594,6.984-15.594,15.594s6.969,15.609,15.594,15.609h111.703   c8.609,0,15.594-7,15.594-15.609S320.469,434.516,311.859,434.516z" style="fill: currentColor;"></path>
                            <path class="st0" d="M256.375,512c15.172,0,28.359-8.484,35.094-20.953h-70.188C228.031,503.516,241.219,512,256.375,512z" style="fill: currentColor;"></path>
                        </g>
                    </svg>
                    <span>{{'STR_JUDGE_DIV_EXPLANATION' | translate}}</span>
                </button>
                <ul>
                    <li>
                        {{'STR_THISTIME' | translate}}
                    </li>
                    <li>
                        {{'STR_LASTTIME' | translate}}
                    </li>
                    <li>
                        {{'STR_STANDARD_VALUE_UNIT' | translate}}
                    </li>
                </ul>
            </div>
            <div *ngFor="let item of objData?.ExaminationResults" class="box-common mb-2">
                <div class="tlt-dot tlt-dot-flex tlt-border-tlt m-0">
                    <span>{{item.ExaminationCategoryName}}</span>
                    <div class="tlt-result">
                        <div>
                            <div class="text-view-radius">
                                <span *ngIf="!util.isNullOrBlank(item.CurrentValue)"
                                    [ngClass]="{'text-red' : item.CurrentValue === 'D2' || item.CurrentValue === 'D1' }">{{item.CurrentValue}}</span>
                                <span *ngIf="util.isNullOrBlank(item.CurrentValue)">-</span>
                            </div>
                        </div>
                        <div>
                            <div class="text-view-radius white">
                                <span *ngIf="!util.isNullOrBlank(item.LastValue)"
                                    [ngClass]="{'text-red' : item.LastValue === 'D2' || item.LastValue === 'D1' }">{{item.LastValue}}</span>
                                <span *ngIf="util.isNullOrBlank(item.LastValue)">-</span>
                            </div>
                        </div>
                    </div>
                </div>
                <details>
                    <summary>
                        <div class="mark-carret"></div>
                    </summary>
                    <div class="tlt-dot-desc">
                        <p>{{item.ExaminationComment}}</p>
                    </div>
                    <div class="table-common">
                        <table>
                            <tbody>
                                <tr *ngFor="let it of item.ItemResults">
                                    <td [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">
                                        <b>{{it.HTItemName}}</b>
                                    </td>
                                    <td *ngIf="it.CurrentValue" [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">
                                        <div class="span-arrow" [ngClass]="{'active': checkHLbyJugdiv(it.CurrentJugdiv) === 'L' || checkHLbyJugdiv(it.CurrentJugdiv) === 'H'}">
                                            <span>{{roundValue(it.CurrentValue,it.HTResultFractionCalDiv,it.Decimal , it.ResultType)}}</span>
                                            <span *ngIf="checkHLbyJugdiv(it.CurrentJugdiv) === 'L'"class="text-blue arrow-icon">&darr;</span>
                                            <span *ngIf="checkHLbyJugdiv(it.CurrentJugdiv) === 'H'" class="text-red arrow-icon">&uarr;</span>
                                        </div>
                                    </td>
                                    <td *ngIf="!it.CurrentValue" [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">-</td>
                                    <td *ngIf="it.LastValue" [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">
                                        <div class="span-arrow" [ngClass]="{'active': checkHLbyJugdiv(it.CurrentJugdiv) === 'L' || checkHLbyJugdiv(it.LastJugDiv) === 'H'}">
                                            <span>{{roundValue(it.LastValue,it.HTResultFractionCalDiv,it.Decimal, it.ResultType)}}</span>
                                            <span *ngIf="checkHLbyJugdiv(it.LastJugDiv) === 'L'" class="text-blue arrow-icon">&darr;</span>
                                            <span *ngIf="checkHLbyJugdiv(it.LastJugDiv) === 'H'" class="text-red arrow-icon">&uarr;</span>
                                        </div>
                                    </td>
                                    <td *ngIf="!it.LastValue" [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">
                                        <span>-</span>
                                    </td>
                                    <td *ngIf="it.ResultType != '3' && it.ResultType != '4' && it.ResultType != '5' " class="text-right" [ngClass]="{'active-td': it.ResultType == '3' || it.ResultType == '4' || it.ResultType == '5'}">{{it.DispStandardValueAndUnit}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </details>
            </div>
            <div *ngFor="let item of objData?.SpecItems" class="text-view-dot mb-2">
                <span>{{item.HTItemName}}</span>
                <div class="desc">
                    <div class="text-view-radius">
                        <span>{{item.ResultValue}}</span>
                    </div>
                </div>
            </div>
            <div class="tlt-border mb-2 mt-4">
                {{'STR_SUPPLEMENT_INFOMATION' | translate}}
            </div>
            <div *ngIf="objData?.SupplementComment" class="box-common mb-2">
                <div class="tlt-dot m-0">
                    {{'STR_SUPPLEMENT_COMMENT' | translate}}
                </div>
                <div class="box-desc">
                    <p class="mb-0">{{objData?.SupplementComment}}</p>
                </div>
            </div>
            <div class="box-common mb-2">
                <div class="tlt-dot m-0">
                    {{'STR_MEDICAL_HISTORY' | translate}}
                </div>
                <div class="box-desc">
                    <p class="mb-0">{{objData?.MedicalHistory}}</p>
                </div>
            </div>
            <div class="box-common mb-2">
                <div class="tlt-dot m-0">
                    {{'STR_HISTORY_OF_PRESENT_ILLESS' | translate}}
                </div>
                <div class="box-desc">
                    <p class="mb-0">{{objData?.CurrentMedicalHistory}}</p>
                </div>
            </div>
            <div class="box-common mb-2">
                <div class="tlt-dot m-0">
                    {{'STR_SUBJECTIVE_SYMPTOMS' | translate}}
                </div>
                <div class="box-desc">
                    <p class="mb-0">{{objData?.SubjectiveSymtoms}}</p>
                </div>
            </div>

            <div class="line-dot" [(innerHTML)]="objData.ReportNote"></div>
            <div class="text-right mt-2">
                <div class="text-view-red">
                    <label>{{'STR_JUDGE_DOCTOR' | translate}}</label>
                    <div class="desc">
                        <span>{{objData.JudgeDoctor}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="text-center mt-3">
            <button (click)="backToppage()" class="btn btn-common btn-bg-yellow">
                {{'STR_BTN_BACK'|translate}}
            </button>
        </div>
    </div>
</div>
